import { render, staticRenderFns } from "./blogsFilter.vue?vue&type=template&id=8829e2c2&"
import script from "./blogsFilter.vue?vue&type=script&lang=js&"
export * from "./blogsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports